module.exports = __webpack_public_path__ + "static/media/inventory-clearance-event-banner.4be4cd68.jpg";